export function filterResultList(resultsArray, teamID) {
  let filteredList = resultsArray;

  if (teamID) {
    filteredList = resultsArray.filter(item => teamID === item.HomeTeamID || teamID === item.AwayTeamID);
  }

  return filteredList;
}
